(function(){
  if (window.__bfcmVip) return;
  window.__bfcmVip = true;

  var pad = function(n){ return String(n).padStart(2, '0'); };
  var formatters = {};
  var targets = {};
  var barBindings = new WeakMap();
  var topbarBindings = new WeakMap();

  function getFormatter(timeZone){
    if (!formatters[timeZone]) {
      formatters[timeZone] = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
    }
    return formatters[timeZone];
  }

  function getZonedParts(timestamp, timeZone){
    try {
      var parts = getFormatter(timeZone).formatToParts(new Date(timestamp));
      var result = {};
      parts.forEach(function(part){ if (part.type !== 'literal') result[part.type] = Number(part.value); });
      return result;
    } catch (error) {
      return null;
    }
  }

  function getTimeZoneOffset(timestamp, timeZone){
    var parts = getZonedParts(timestamp, timeZone);
    if (!parts) return NaN;
    return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second) - timestamp;
  }

  function parseStoreLocalTarget(value, timeZone){
    var cacheKey = timeZone + '|' + value;
    if (Object.prototype.hasOwnProperty.call(targets, cacheKey)) return targets[cacheKey];
    var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value || '');
    if (!match) return (targets[cacheKey] = NaN);
    var year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    var hour = Number(match[4]), minute = Number(match[5]), second = Number(match[6] || 0);
    var utc = Date.UTC(year, month - 1, day, hour, minute, second);
    var offset = getTimeZoneOffset(utc, timeZone);
    if (isNaN(offset)) return (targets[cacheKey] = NaN);
    var target = utc - offset;
    var adjustedOffset = getTimeZoneOffset(target, timeZone);
    if (isNaN(adjustedOffset)) return (targets[cacheKey] = NaN);
    if (adjustedOffset !== offset) target = utc - adjustedOffset;
    var parts = getZonedParts(target, timeZone);
    if (!parts || parts.year !== year || parts.month !== month || parts.day !== day || parts.hour !== hour || parts.minute !== minute || parts.second !== second) return (targets[cacheKey] = NaN);
    return (targets[cacheKey] = target);
  }

  function elements(root, selector){
    var found = [];
    if (root.matches && root.matches(selector)) found.push(root);
    return found.concat([].slice.call(root.querySelectorAll(selector)));
  }

  function tick(root){
    elements(root || document, '[data-bfcm-countdown]').forEach(function(el){
      var target = parseStoreLocalTarget(el.getAttribute('data-local-target'), el.getAttribute('data-time-zone'));
      if (isNaN(target)) {
        el.setAttribute('data-bfcm-time-error', 'true');
        return;
      }
      el.removeAttribute('data-bfcm-time-error');
      var diff = Math.max(0, target - Date.now()) / 1000;
      var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = Math.floor(diff % 60);
      var set = function(key, value){ elements(el, '[data-u="' + key + '"]').forEach(function(node){ node.textContent = value; }); };
      set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      set('short', d + 'd ' + pad(h) + 'h ' + pad(m) + 'm');
    });
  }

  function parseDateKey(value){
    var match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return NaN;
    var date = Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    var check = new Date(date);
    return check.getUTCFullYear() === Number(match[1]) && check.getUTCMonth() === Number(match[2]) - 1 && check.getUTCDate() === Number(match[3]) ? date : NaN;
  }

  function phases(root){
    elements(root || document, '[data-bfcm-timeline]').forEach(function(timeline){
      var nowParts = getZonedParts(Date.now(), timeline.getAttribute('data-time-zone'));
      if (!nowParts) {
        timeline.setAttribute('data-bfcm-time-error', 'true');
        return;
      }
      timeline.removeAttribute('data-bfcm-time-error');
      var now = Date.UTC(nowParts.year, nowParts.month - 1, nowParts.day);
      var items = elements(timeline, '[data-start]');
      var current = -1;
      items.forEach(function(item, index){
        var start = parseDateKey(item.getAttribute('data-start'));
        var end = parseDateKey(item.getAttribute('data-end') || item.getAttribute('data-start'));
        if (!isNaN(start) && !isNaN(end) && now >= start && now <= end) current = index;
      });
      items.forEach(function(item, index){
        var start = parseDateKey(item.getAttribute('data-start'));
        var end = parseDateKey(item.getAttribute('data-end') || item.getAttribute('data-start'));
        item.classList.toggle('is-now', index === current);
        item.classList.toggle('is-past', !isNaN(end) && end < now);
        item.classList.toggle('is-upcoming', !isNaN(start) && start > now);
      });
      timeline.classList.toggle('is-complete', items.length > 0 && current === -1 && items.every(function(item){ return parseDateKey(item.getAttribute('data-end') || item.getAttribute('data-start')) < now; }));
    });
  }

  function sectionRoot(element){
    return element.closest('[id^="shopify-section-"]') || document;
  }

  function clearBinding(bindings, element){
    var binding = bindings.get(element);
    if (!binding) return;
    binding.disconnect();
    if (binding.remove) binding.remove();
    bindings.delete(element);
  }

  function bar(root){
    elements(root || document, '[data-bfcm-bar]').forEach(function(barElement){
      clearBinding(barBindings, barElement);
      var form = sectionRoot(barElement).querySelector('[data-bfcm-formwrap]') || document.querySelector('[data-bfcm-formwrap]');
      if (!form) return;
      document.body.classList.add('bfcm-has-bar');
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ barElement.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0); });
      });
      observer.observe(form);
      barBindings.set(barElement, { disconnect: function(){ observer.disconnect(); } });
    });
  }

  function topbar(root){
    elements(root || document, '[data-bfcm-top-ph]').forEach(function(placeholder){
      var top = placeholder.querySelector('[data-bfcm-top]');
      if (!top) return;
      clearBinding(topbarBindings, placeholder);
      var setHeight = function(){ placeholder.style.height = top.offsetHeight + 'px'; };
      setHeight();
      window.addEventListener('resize', setHeight);
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){ top.classList.toggle('is-fixed', !entry.isIntersecting && entry.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      observer.observe(placeholder);
      topbarBindings.set(placeholder, { disconnect: function(){ observer.disconnect(); }, remove: function(){ window.removeEventListener('resize', setHeight); } });
    });
  }

  function destroy(root){
    elements(root, '[data-bfcm-bar]').forEach(function(element){ clearBinding(barBindings, element); });
    elements(root, '[data-bfcm-top-ph]').forEach(function(element){ clearBinding(topbarBindings, element); });
  }

  function copyLink(button, url){
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(url).then(function(){
      button.removeAttribute('data-bfcm-copy-error');
      button.textContent = button.getAttribute('data-copied') || 'Link copied';
    }).catch(function(){ button.setAttribute('data-bfcm-copy-error', 'true'); });
  }

  document.addEventListener('click', function(event){
    var go = event.target.closest('[data-bfcm-goto-form]');
    if (go) {
      var form = sectionRoot(go).querySelector('[data-bfcm-formwrap]') || document.querySelector('[data-bfcm-formwrap]');
      if (form) {
        event.preventDefault();
        window.scrollTo({ top: form.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
        var input = form.querySelector('input[type=email]');
        if (input) setTimeout(function(){ input.focus({ preventScroll: true }); }, 500);
      }
    }
    var share = event.target.closest('[data-bfcm-share]');
    if (share) {
      event.preventDefault();
      var url = location.href.split('?')[0];
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).then(function(){ share.removeAttribute('data-bfcm-share-error'); }).catch(function(error){ if (!error || error.name !== 'AbortError') share.setAttribute('data-bfcm-share-error', 'true'); });
      } else {
        copyLink(share, url);
      }
    }
  });

  function init(root){
    tick(root || document);
    phases(root || document);
    bar(root || document);
    topbar(root || document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  setInterval(function(){ tick(document); }, 1000);
  setInterval(function(){ phases(document); }, 60000);
  document.addEventListener('shopify:section:load', function(event){ init(event.target || document); });
  document.addEventListener('shopify:section:unload', function(event){ destroy(event.target || document); });
})();
